import { Menu as BaseMenu } from "@base-ui/react/menu";
import type { ComponentProps } from "react";
import { cn } from "../utils";

export const Menu = BaseMenu.Root;
export const MenuTrigger = BaseMenu.Trigger;

export function MenuContent({
  className,
  children,
  side,
  align = "end",
  ...props
}: ComponentProps<typeof BaseMenu.Popup> & {
  side?: "top" | "bottom" | "left" | "right";
  align?: "start" | "center" | "end";
}) {
  return (
    <BaseMenu.Portal>
      <BaseMenu.Positioner
        sideOffset={4}
        side={side}
        align={align}
        className="z-50 outline-none"
      >
        <BaseMenu.Popup
          className={cn(
            "min-w-40 rounded-surface border border-line bg-surface-overlay p-1 shadow-overlay",
            "origin-[var(--transform-origin)] transition-[transform,opacity] duration-150 ease-swift",
            "data-[starting-style]:scale-95 data-[starting-style]:opacity-0",
            "data-[ending-style]:scale-95 data-[ending-style]:opacity-0",
            className,
          )}
          {...props}
        >
          {children}
        </BaseMenu.Popup>
      </BaseMenu.Positioner>
    </BaseMenu.Portal>
  );
}

export function MenuItem({
  className,
  ...props
}: ComponentProps<typeof BaseMenu.Item>) {
  return (
    <BaseMenu.Item
      className={cn(
        "flex cursor-pointer items-center gap-2 rounded-control px-2 py-1.5",
        "text-[0.8125rem] text-ink-secondary outline-none",
        "transition-[background-color,color,transform] duration-100 ease-swift",
        "active:scale-[0.98]",
        "data-[highlighted]:bg-surface-sunken data-[highlighted]:text-ink",
        "[&_svg]:size-3.5 [&_svg]:text-ink-muted",
        className,
      )}
      {...props}
    />
  );
}

export function MenuSeparator({
  className,
  ...props
}: ComponentProps<typeof BaseMenu.Separator>) {
  return (
    <BaseMenu.Separator
      className={cn("-mx-1 my-1 h-px bg-line", className)}
      {...props}
    />
  );
}
